import ModifyTagsPage from "./utils/ModifyTagsPage";
import ModifyNavigationOrder from "./utils/ModifyNavigationOrder";
import ModifyDiscussionPage from "./utils/ModifyDiscussionPage";
import ModifyDiscussionsListPage from "./utils/ModifyDiscussionsListPage";
import ModifyUserDirectoryPage from "./utils/ModifyUserDirectoryPage";
import ModifyUserProfilePage from "./utils/ModifyUserProfilePage";
import ModifyMasqueradePage from "./utils/ModifyMasqueradePage";
import AddAnswerComments from "./utils/AddAnswerComments";
import AddDiscussionSubscribeAction from "./utils/AddDiscussionSubscribeAction";
import AddAnswersCountIndicator from "./utils/AddAnswersCountIndicator";
import AddAdvCommentsNotifications from "./utils/AddAdvCommentsNotifications";
import AddLoadMore from "./utils/AddLoadMore";
import AddProfessionalAchievements from "./utils/AddProfessionalAchievements";
import AddUserSubscriptions from "./utils/AddUserSubscriptions";
import AddUserAdvComments from "./utils/AddUserAdvComments";
import ModifyUserPoints from "./utils/ModifyUserPoints";
import ModifyUserHero from "./utils/ModifyUserHero";
import AddAdvRankings from "./utils/AddAdvRankings";
import ModifyTagDiscussionModal from "./utils/ModifyTagDiscussionModal";

const fofUserDirectory = require("@fof-user-directory");
const { BaseField } = require("@fof-masquerade");

app.initializers.add("tolyod/flarum-ext-advdiscus", () => {
  console.log("[tolyod/flarum-ext-advdiscus] starting yay 1");

  AddAdvCommentsNotifications(); // done
  AddAnswersCountIndicator();
  AddAnswerComments(); // done
  AddDiscussionSubscribeAction();
  ModifyTagsPage();
  ModifyDiscussionPage();
  ModifyDiscussionsListPage();
  ModifyNavigationOrder();
  if (fofUserDirectory) {
    ModifyUserDirectoryPage(fofUserDirectory);
  }
  ModifyUserProfilePage();
  ModifyMasqueradePage(BaseField);
  ModifyUserPoints(); // done
  AddLoadMore();
  AddProfessionalAchievements();
  AddUserSubscriptions();
  AddUserAdvComments(); // done
  ModifyUserHero();
  AddAdvRankings(); // done
  // ModifyTagDiscussionModal();

  // m.mount(document.getElementById('header-secondary'), HeaderSecondary);
});

